export enum CheckinSteps {
  SIZE_CARD = 'size_card',
  TERMS = 'terms',
  QUESTIONS = 'questions',
  COMPLETE = 'complete',
}
